<app-navbar></app-navbar>
<main>
  <router-outlet></router-outlet>
</main>
<app-alert></app-alert>
